import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getModuleMeta } from '../redux/selectors/modules';
import { updateModule } from '../redux/actions/modules';
import { useGruser } from './useGruser';
export const useModuleMeta = (moduleId)=>{
    const { gruser } = useGruser();
    const dispatch = useDispatch();
    const moduleMeta = useSelector((state)=>getModuleMeta(state, gruser, moduleId));
    const updateModuleMeta = useCallback((meta)=>dispatch(updateModule(gruser, {
            id: moduleId,
            moduleMeta: meta
        })), [
        dispatch,
        gruser,
        moduleId
    ]);
    return {
        moduleMeta,
        updateModuleMeta
    };
};
export default useModuleMeta;

//# sourceMappingURL=useModuleMeta.js.map